import React from "react";

import MDInput from "materialDashboard/components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {useTranslation} from "react-i18next";


const UserConfirmedAtIsNullAutocomplete = ({ selected, setSelected, ...props }) => {
    const {t} = useTranslation("inputs");

    const isActiveLabels = {
        [true]: t(`userConfirmedAtIsNullAutocomplete.notConfirmed`),
        [false]: t(`userConfirmedAtIsNullAutocomplete.confirmed`),
    }

    const isActiveOptions = Object.keys(isActiveLabels)
    return <Autocomplete
        value={selected}
        options={isActiveOptions}
        getOptionLabel={(s) => isActiveLabels[s]}
        filterOptions={(x) => x}
        onChange={(e, value) => setSelected(value)}
        renderInput={(params) => (
            <MDInput {...params}
                     variant="standard"
                     label={t('userConfirmedAtIsNullAutocomplete.label')}
                     placeholder={t('userConfirmedAtIsNullAutocomplete.placeholder')}
            />
        )}
        {...props}
    />
}

export default UserConfirmedAtIsNullAutocomplete;